import SurveyService from './SurveyService.js';

const service = new SurveyService();

export default {
  key: 'survey',
  namespaced: true,
  state: {},
  actions: {
    dismiss({commit}, payload = {}) {
      return service.dismiss(payload);
    },
    prompt({commit}, payload = {}) {
      return service.prompt(payload);
    },
    submit({commit}, payload = {}) {
      return service.submit(payload);
    },
    viewed({commit}, payload = {}) {
      return service.viewed(payload);
    },
  },
  mutations: {},
};
